import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { messages } from '../../messages';
import { EcoPackagingState } from '../../model';

export interface IEcoPackagingDescriptionProps extends IBasicStyledProps {
  state: EcoPackagingState;
}

export const EcoPackagingDescription: ReactFCV<IEcoPackagingDescriptionProps> = ({ state }) => {
  switch (state) {
    case EcoPackagingState.DISABLED_DISCO:
      return <FormattedMessage {...messages.dicoveryWithEcoCantCombineDescription} />;
    case EcoPackagingState.DISABLED_GIFT:
      return <FormattedMessage {...messages.giftWithEcoCantCombineDescription} />;
    case EcoPackagingState.ENABLED:
      return <FormattedMessage {...messages.ecoWrappingDescription} />;
    default:
      return null;
  }
};
